import { Edit2, KeyRound, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { UserMobileCardProps } from './userTypes';

export function UserMobileCard({
  user,
  roleCatalog,
  currentUserId,
  onEditRoles,
  onResetPassword,
  onDelete
}: UserMobileCardProps) {
  return (
    <Card className="shadow-sm overflow-hidden">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <div className="font-semibold truncate">{user.name}</div>
            <div className="text-sm text-muted-foreground truncate">{user.username}</div>
            <div className="text-xs text-muted-foreground break-words">
              {user.email.split('@')[0]}<wbr />@{user.email.split('@')[1]}
            </div>
          </div>
          <Badge variant={user.isActive ? 'secondary' : 'destructive'} className="flex-shrink-0">
            {user.isActive ? 'Ativo' : 'Inativo'}
          </Badge>
        </div>

        <div>
          <div className="text-xs text-muted-foreground mb-1">Papeis</div>
          <div className="flex flex-wrap gap-1">
            {user.roles.map((role) => {
              const roleInfo = roleCatalog.find((r) => r.id === role);
              return (
                <Badge key={role} variant="secondary" className="text-xs">
                  {roleInfo?.label || role}
                </Badge>
              );
            })}
          </div>
        </div>

        <div className="text-xs text-muted-foreground pt-2 border-t">
          Criado em: {new Date(user.createdAt).toLocaleDateString()}
        </div>

        <div className="flex flex-wrap gap-2 pt-2 border-t">
          <Button
            variant="default"
            size="sm"
            className="flex-1"
            onClick={() => onEditRoles(user)}
          >
            <Edit2 className="mr-2 h-4 w-4" />
            Editar papeis
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={() => onResetPassword(user)}
          >
            <KeyRound className="mr-2 h-4 w-4" />
            Senha
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onDelete(user)}
            disabled={user.id === currentUserId}
            title={user.id === currentUserId ? 'Nao pode deletar seu proprio usuario' : 'Deletar usuario'}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
